module.exports = __webpack_public_path__ + "img/11.03edd2d9.png";